var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeeline = function SvgBeeline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    d: "M11.9982 22.9974C18.0715 22.9974 22.9948 18.0732 22.9948 11.9987C22.9948 5.9243 18.0715 1 11.9982 1C5.92485 1 1.00146 5.9243 1.00146 11.9987C1.00146 18.0732 5.92485 22.9974 11.9982 22.9974Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B242C",
    d: "M16.7306 20.1929C12.9961 22.3483 8.94594 22.7346 6.35889 21.4435C9.67109 23.4174 13.9239 23.5882 17.4984 21.5246C21.073 19.4588 23.0522 15.6902 22.9989 11.834C22.824 14.7213 20.4652 18.0376 16.7306 20.1929Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B242C",
    d: "M13.3928 1.80715C14.15 3.11743 12.32 5.5929 9.30423 7.33214C6.28848 9.07134 3.23219 9.42134 2.47505 8.10889C2.44306 8.04704 2.4132 7.97874 2.39187 7.90829C2.19565 7.29799 2.43026 6.50839 2.99545 5.67612C3.08716 5.54595 3.181 5.41791 3.27698 5.292C4.1301 4.18018 5.21142 3.2156 6.49963 2.47296C7.78783 1.72819 9.16348 1.27578 10.5519 1.09225C10.714 1.06878 10.8719 1.0517 11.0254 1.04103C12.0278 0.966344 12.8276 1.15841 13.2584 1.63216C13.3096 1.68978 13.3544 1.74739 13.3928 1.80715Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B242C",
    d: "M18.0679 3.22553C19.3902 5.51534 16.7221 9.5294 12.111 12.1927C7.49995 14.856 2.68834 15.159 1.36814 12.8692C1.14847 12.4872 1.03116 12.0625 1.0077 11.6058C0.950116 13.1445 1.21458 14.7087 1.83096 16.194C1.92267 16.4159 2.02291 16.6357 2.12955 16.8534C2.13381 16.8619 2.14022 16.8726 2.14448 16.8811C2.54331 17.5704 3.13196 18.1125 3.86564 18.5051C6.45275 19.8901 10.8271 19.4142 14.9178 17.0519C19.0063 14.6895 21.6063 11.1406 21.7022 8.20845C21.7299 7.38045 21.5572 6.60155 21.1626 5.91226C21.0133 5.68819 20.8576 5.46839 20.6934 5.25925C19.7229 4.00445 18.5158 3.00573 17.1743 2.29297C17.5475 2.53838 17.8504 2.84781 18.0679 3.22553C18.0679 3.22553 18.07 3.22767 18.07 3.2298L18.0679 3.22553Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_9530_13622)",
    d: "M12.0006 22.9974C18.0739 22.9974 22.9973 18.0732 22.9973 11.9987C22.9973 5.9243 18.0739 1 12.0006 1C5.92729 1 1.00391 5.9243 1.00391 11.9987C1.00391 18.0732 5.92729 22.9974 12.0006 22.9974Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9530_13622",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.9996 11.9996) scale(10.9965 11.0027)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })))));
};
export default SvgBeeline;